import { createApiConstants } from '@saucelabs/sl-util-redux';

export const NAMESPACE = 'flatJobs';

export const CLEANUP = `${NAMESPACE}/CLEANUP`;
export const CLEAR_RDC_OFFSET = `${NAMESPACE}/CLEAR_RDC_OFFSET`;
export const DECREASE_RDC_OFFSET = `${NAMESPACE}/DECREASE_RDC_OFFSET`;
export const INCREASE_RDC_OFFSET = `${NAMESPACE}/INCREASE_RDC_OFFSET`;
export const SET_CLOUD_TYPE = `${NAMESPACE}/SET_CLOUD_TYPE`;

export const ARCHIVED_RDC_JOBS_GET = createApiConstants(NAMESPACE, 'ARCHIVED_RDC_JOBS_GET');
export const ARCHIVED_JOBS_GET = createApiConstants(NAMESPACE, 'ARCHIVED_JOBS_GET');
export const CHANGE_PAGE = `${NAMESPACE}/CHANGE_PAGE`;
export const CHANGE_PER_PAGE = `${NAMESPACE}/CHANGE_PER_PAGE`;
export const RESET_PAGE = `${NAMESPACE}/RESET_PAGE`;
export const SHOW_LOADER = `${NAMESPACE}/SHOW_LOADER`;
